module.exports = __webpack_public_path__ + "img/bg_content_header_01.df0c628.png";